import {useEffect, useState} from 'react';
import {useDateNow} from './useDateNow';

export const useRemainingTime = (
  endDate?: Date,
  tickInterval = 1000,
): number => {
  const [disabled, setDisabled] = useState(false);
  const now = useDateNow(disabled ? false : tickInterval);

  const endDateTime = endDate ? new Date(endDate).valueOf() : 0;
  const remaining = Math.max(0, endDateTime - now);
  const ended = remaining === 0;

  useEffect(() => setDisabled(ended), [ended]);

  return endDate ? remaining : 0;
};
